
import { requests } from '.'
import { Filter } from '../commons/Types';
import Faq from '../models/Faq.model';
import ListData from '../models/List.model';

export const FaqApi = {
  list: (filter: Filter) => requests.get<ListData<Faq>>('v1/faq', filter), 
};